import { render } from "./LoginUser.vue?vue&type=template&id=637f4748&scoped=true"
import script from "./LoginUser.vue?vue&type=script&lang=js"
export * from "./LoginUser.vue?vue&type=script&lang=js"

import "./LoginUser.vue?vue&type=style&index=0&id=637f4748&scoped=true&lang=css"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637f4748"]])

export default __exports__